module.exports = __webpack_public_path__ + "fonts/SanFranciscoDisplay-Medium.2d4285bb.woff";